import { createContext, useContext } from "react";
import type { IntakeMachine } from "./useIntakeMachine";

const IntakeContext = createContext<IntakeMachine | null>(null);

export const IntakeProvider = IntakeContext.Provider;

export function useIntake(): IntakeMachine {
  const ctx = useContext(IntakeContext);
  if (!ctx) throw new Error("useIntake must be used within an IntakeProvider");
  return ctx;
}
